import { cn } from '@/utlis/cn'

type AccentBadgeProps = {
    className?: string
    subText?: string
    variant?: 'highlight' | 'gray'
    children?: React.ReactNode
}

const outerStyles = {
    highlight: 'bg-[rgba(252,221,64,0.15)] rounded-full w-[90px] h-[90px] border-1 border-white/5 backdrop-blur-xs',
    gray: 'bg-[rgba(255,255,255,0.15)] rounded-full w-[90px] h-[90px] border-1 border-white/5 backdrop-blur-xs',
}

const innerStyles = {
    highlight: 'bg-[rgba(252,221,64,0.15)] rounded-full w-[70px] h-[70px] border-1 border-white/5',
    gray: 'bg-[rgba(255,255,255,0.15)] rounded-full w-[70px] h-[70px] border-1 border-white/5',
}

export function AccentBadge(props: AccentBadgeProps) {
    const outerLayout = 'flex items-center justify-center'
    const outerStyle = outerStyles[props.variant ?? 'highlight']

    const innerLayout = 'flex items-center justify-center'
    const innerStyle = innerStyles[props.variant ?? 'highlight']

    return (
        <div className={cn('flex flex-col gap-2 items-center justify-center', props.className)}>
            <div className={cn(outerStyle, outerLayout)}>
                <div className={cn(innerStyle, innerLayout)}>{props.children}</div>
            </div>
            {props.subText && <span className="t-base-light opacity-60">{props.subText}</span>}
        </div>
    )
}

export function AccentBadgeNumber({ children }: { children: React.ReactNode }) {
    return <div className="relative font-light text-[30px] text-muse-yellow pt-[5px]">{children}</div>
}
